module.exports = __webpack_public_path__ + "media/images/ic-pin-gray-fullfiled-72e3d54b6214eca9d00a603320d1e7d2.svg";